module.exports = __webpack_public_path__ + "img/92.3.TP.c6251541.png";